import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
  :root {
    --navy:#000080;--navy-light:#1a1a9a;--navy-dark:#00004d;--navy-dim:rgba(0,0,128,0.15);
    --red:#A00048;--red-bright:#c0005a;--red-dim:rgba(160,0,72,0.15);
    --gold:#d4a017;--gold-bright:#f0b429;
    --green:#006400;--green-bright:#22c55e;
    --bg:#04040f;--bg2:#08081e;--bg3:#0d0d28;--bg4:#111135;
    --border:rgba(0,0,128,0.25);--border-hi:rgba(0,0,128,0.5);
    --text:#e8eaf4;--text2:#8892c4;--text3:#3a4070;
    --font:'Poppins',sans-serif;--mono:'DM Mono',monospace;
  }
  *{box-sizing:border-box;margin:0;padding:0;}
  body{background:var(--bg);color:var(--text);font-family:var(--font);font-size:14px;line-height:1.5;min-height:100vh;}

  .header{background:var(--navy-dark);border-bottom:2px solid var(--red);padding:0 28px;height:60px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:100;}
  .header-left{display:flex;align-items:center;gap:20px;}
  .logo{font-family:var(--font);font-weight:800;font-size:22px;letter-spacing:.12em;color:#fff;text-transform:uppercase;}
  .logo-accent{color:var(--gold-bright);}
  .logo-sub{font-size:9px;font-weight:400;letter-spacing:.16em;color:rgba(255,255,255,.4);text-transform:uppercase;border-left:1px solid rgba(255,255,255,.15);padding-left:16px;line-height:1.5;}
  .header-right{display:flex;align-items:center;gap:14px;}
  .live-badge{display:flex;align-items:center;gap:6px;background:var(--red-dim);border:1px solid rgba(160,0,72,.5);border-radius:3px;padding:4px 12px;font-family:var(--mono);font-size:10px;color:var(--red-bright);letter-spacing:.12em;text-transform:uppercase;}
  .live-dot{width:6px;height:6px;border-radius:50%;background:var(--red-bright);animation:pulse 1.5s ease-in-out infinite;}
  @keyframes pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.4;transform:scale(.7);}}
  .clock{font-family:var(--mono);font-size:13px;color:rgba(255,255,255,.55);letter-spacing:.06em;}

  .summary-bar{background:var(--bg2);border-bottom:1px solid var(--border);padding:14px 28px;display:flex;gap:24px;align-items:center;flex-wrap:wrap;}
  .stat-block{display:flex;flex-direction:column;gap:3px;}
  .stat-label{font-family:var(--mono);font-size:9px;color:var(--text3);letter-spacing:.14em;text-transform:uppercase;}
  .stat-val{font-weight:700;font-size:24px;color:var(--text);line-height:1;}
  .stat-val .d{font-size:14px;font-weight:400;color:var(--text3);}
  .stat-val.gold{color:var(--gold-bright);}
  .stat-val.red{color:var(--red-bright);}
  .div{width:1px;height:36px;background:var(--border);}
  .prog-wrap{flex:1;min-width:160px;display:flex;flex-direction:column;gap:5px;}
  .prog-labels{display:flex;justify-content:space-between;font-family:var(--mono);font-size:9px;color:var(--text3);letter-spacing:.1em;text-transform:uppercase;}
  .prog-labels span:last-child{color:var(--gold-bright);font-weight:500;}
  .prog-track{height:3px;background:var(--bg4);border-radius:2px;overflow:hidden;}
  .prog-fill{height:100%;background:linear-gradient(90deg,var(--navy-light),var(--red));border-radius:2px;transition:width 1s ease;}
  .updated{font-family:var(--mono);font-size:9px;color:var(--text3);letter-spacing:.08em;margin-left:auto;white-space:nowrap;}

  .tab-nav{background:var(--bg2);border-bottom:1px solid var(--border);padding:0 28px;display:flex;}
  .tab-btn{padding:13px 20px;background:none;border:none;border-bottom:2px solid transparent;color:var(--text3);font-family:var(--font);font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:all .15s;margin-bottom:-1px;}
  .tab-btn:hover{color:var(--text2);}
  .tab-btn.active{color:var(--gold-bright);border-bottom-color:var(--gold-bright);}

  .main{padding:20px 28px;}

  .filters{display:flex;gap:6px;margin-bottom:18px;flex-wrap:wrap;}
  .fbtn{padding:5px 12px;background:var(--bg2);border:1px solid var(--border);border-radius:3px;color:var(--text3);font-family:var(--mono);font-size:9px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:all .15s;}
  .fbtn:hover{border-color:var(--border-hi);color:var(--text2);}
  .fbtn.active{background:var(--navy-dim);border-color:rgba(0,0,128,.6);color:#8899ff;}

  .sec-hdr{display:flex;align-items:center;gap:10px;margin-bottom:14px;}
  .sec-title{font-size:11px;font-weight:700;color:var(--text3);letter-spacing:.14em;text-transform:uppercase;}
  .sec-ct{font-family:var(--mono);font-size:10px;color:var(--text3);}

  .races-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(310px,1fr));gap:10px;}

  .race-card{background:var(--bg2);border:1px solid var(--border);border-radius:5px;padding:15px;cursor:pointer;transition:border-color .15s,transform .1s;position:relative;overflow:hidden;}
  .race-card:hover{border-color:var(--border-hi);transform:translateY(-1px);}
  .race-card.called{border-color:rgba(0,100,0,.4);}
  .race-card.called::before,.race-card.live::before{content:'';position:absolute;left:0;top:0;bottom:0;width:3px;}
  .race-card.called::before{background:var(--green);}
  .race-card.live{border-color:rgba(160,0,72,.35);}
  .race-card.live::before{background:var(--red);}

  .race-hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:12px;gap:8px;}
  .race-office{font-size:11px;font-weight:700;color:var(--text);line-height:1.35;flex:1;text-transform:uppercase;letter-spacing:.04em;}
  .badge{font-family:var(--mono);font-size:8px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;padding:2px 7px;border-radius:2px;white-space:nowrap;flex-shrink:0;}
  .badge.called{background:rgba(0,100,0,.15);color:var(--green-bright);border:1px solid rgba(0,100,0,.3);}
  .badge.live{background:var(--red-dim);color:var(--red-bright);border:1px solid rgba(160,0,72,.35);}
  .badge.pending{background:rgba(58,64,112,.3);color:var(--text3);border:1px solid var(--border);}

  .cands{display:flex;flex-direction:column;gap:9px;margin-bottom:10px;}
  .cand-row{display:flex;flex-direction:column;gap:3px;}
  .cand-info{display:flex;justify-content:space-between;align-items:center;}
  .cand-name{font-size:13px;font-weight:500;color:var(--text);display:flex;align-items:center;gap:6px;}
  .wcheck{color:var(--green-bright);font-size:11px;}
  .inc{font-family:var(--mono);font-size:8px;color:var(--text3);letter-spacing:.08em;text-transform:uppercase;background:var(--bg3);padding:1px 4px;border-radius:2px;}
  .cand-votes{display:flex;align-items:center;gap:10px;}
  .vnum{font-family:var(--mono);font-size:13px;font-weight:500;color:var(--text);}
  .vpct{font-family:var(--mono);font-size:11px;color:var(--text2);min-width:40px;text-align:right;}
  .vpct.lead{color:var(--gold-bright);font-weight:500;}
  .vbar{height:2px;background:var(--bg4);border-radius:1px;overflow:hidden;}
  .vfill{height:100%;border-radius:1px;transition:width .7s ease;}
  .vfill.lead{background:var(--red);}
  .vfill.trail{background:var(--text3);}

  .race-foot{display:flex;justify-content:space-between;align-items:center;padding-top:8px;border-top:1px solid var(--border);}
  .rept{font-family:var(--mono);font-size:9px;color:var(--text3);letter-spacing:.06em;}
  .rept strong{color:var(--text2);}
  .co-tag{font-family:var(--mono);font-size:9px;color:var(--text3);}

  .bw-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
  .bw-card{background:var(--bg2);border:1px solid var(--border);border-radius:5px;padding:16px;}
  .bw-title{font-size:10px;font-weight:700;color:var(--text3);letter-spacing:.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid var(--border);}
  .bw-row{display:flex;justify-content:space-between;align-items:center;padding:7px 0;border-bottom:1px solid var(--border);}
  .bw-row:last-child{border-bottom:none;}
  .bw-l{display:flex;flex-direction:column;gap:1px;}
  .bw-name{font-size:12px;font-weight:600;color:var(--text);}
  .bw-meta{font-family:var(--mono);font-size:9px;color:var(--text3);}
  .bw-r{display:flex;align-items:center;gap:8px;}
  .bw-pct{font-family:var(--mono);font-size:13px;font-weight:500;color:var(--gold-bright);}
  .bw-st{font-family:var(--mono);font-size:8px;padding:2px 6px;border-radius:2px;text-transform:uppercase;letter-spacing:.08em;}
  .bw-st.in{background:rgba(0,100,0,.15);color:var(--green-bright);}
  .bw-st.out{background:var(--bg3);color:var(--text3);}
  .cav{color:var(--gold);font-size:10px;margin-left:3px;}

  .admin-sec{margin-bottom:24px;}
  .admin-tbl{width:100%;border-collapse:collapse;}
  .admin-tbl th{font-family:var(--mono);font-size:9px;color:var(--text3);letter-spacing:.12em;text-transform:uppercase;text-align:left;padding:8px 12px;border-bottom:1px solid var(--border);}
  .admin-tbl td{padding:8px 12px;border-bottom:1px solid var(--border);color:var(--text2);font-family:var(--mono);font-size:11px;}
  .admin-tbl tr:hover td{background:var(--bg3);}
  .ok{color:var(--green-bright);}.err{color:var(--red-bright);}.warn{color:var(--gold-bright);}

  .conf-card{background:var(--bg2);border:1px solid rgba(212,160,23,.35);border-radius:5px;padding:16px;margin-bottom:10px;}
  .conf-hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:12px;}
  .conf-title{font-size:13px;font-weight:600;color:var(--text);}
  .conf-meta{font-family:var(--mono);font-size:10px;color:var(--text2);margin-top:2px;}
  .conf-vals{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px;}
  .conf-val{background:var(--bg3);border-radius:4px;padding:10px;}
  .cv-lbl{font-family:var(--mono);font-size:9px;color:var(--text3);text-transform:uppercase;letter-spacing:.1em;margin-bottom:4px;}
  .cv-num{font-size:22px;font-weight:700;color:var(--text);}
  .cv-src{font-family:var(--mono);font-size:9px;color:var(--text3);margin-top:3px;}
  .conf-acts{display:flex;gap:8px;}
  .btn{padding:7px 16px;border-radius:3px;border:1px solid;font-family:var(--mono);font-size:10px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:all .15s;}
  .btn-a{background:rgba(0,100,0,.12);border-color:rgba(0,100,0,.4);color:var(--green-bright);}
  .btn-k{background:var(--red-dim);border-color:rgba(160,0,72,.4);color:var(--red-bright);}

  .loading{display:flex;align-items:center;justify-content:center;padding:60px;color:var(--text3);font-family:var(--mono);font-size:11px;letter-spacing:.12em;}
  .empty{text-align:center;padding:60px 24px;color:var(--text3);font-family:var(--mono);font-size:12px;letter-spacing:.08em;}
  .err-banner{background:var(--red-dim);border:1px solid rgba(160,0,72,.35);border-radius:4px;padding:10px 16px;margin-bottom:16px;font-family:var(--mono);font-size:11px;color:var(--red-bright);}

  @media(max-width:768px){.races-grid{grid-template-columns:1fr;}.bw-grid{grid-template-columns:1fr;}.logo-sub{display:none;}}
`;

function useLiveData(url, interval = 30000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const fetch_ = useCallback(async () => {
    try {
      const res = await fetch(`${API}${url}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setData(await res.json());
      setLastUpdated(new Date());
      setError(null);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  }, [url]);
  useEffect(() => { fetch_(); const t = setInterval(fetch_, interval); return () => clearInterval(t); }, [fetch_, interval]);
  return { data, loading, error, lastUpdated, refresh: fetch_ };
}

function useClock() {
  const [t, setT] = useState(new Date());
  useEffect(() => { const i = setInterval(() => setT(new Date()), 1000); return () => clearInterval(i); }, []);
  return t;
}

function CandRow({ c, maxV }) {
  const pct = maxV > 0 ? (c.total_votes / maxV) * 100 : 0;
  return (
    <div className="cand-row">
      <div className="cand-info">
        <span className="cand-name">{c.is_winner && <span className="wcheck">✓</span>}{c.full_name}{c.is_incumbent && <span className="inc">inc</span>}</span>
        <div className="cand-votes"><span className="vnum">{(c.total_votes||0).toLocaleString()}</span><span className={`vpct${c.is_leading?' lead':''}`}>{(c.vote_pct||0).toFixed(1)}%</span></div>
      </div>
      <div className="vbar"><div className={`vfill${c.is_leading?' lead':' trail'}`} style={{width:`${pct}%`}}/></div>
    </div>
  );
}

function RaceCard({ race }) {
  const cands = race.candidates || [];
  const maxV = Math.max(...cands.map(c => c.total_votes||0), 1);
  const st = race.race_called ? 'called' : race.precincts_reporting > 0 ? 'live' : 'pending';
  return (
    <div className={`race-card ${st}`}>
      <div className="race-hdr">
        <div className="race-office">{race.office_name}</div>
        <span className={`badge ${st}`}>{st==='called'?'Called':st==='live'?'Live':'Pending'}</span>
      </div>
      <div className="cands">{cands.slice(0,4).map(c=><CandRow key={c.candidate_id} c={c} maxV={maxV}/>)}{cands.length>4&&<div style={{fontSize:10,color:'var(--text3)',fontFamily:'var(--mono)'}}>+{cands.length-4} more</div>}</div>
      <div className="race-foot">
        <span className="rept"><strong>{race.precincts_reporting||0}</strong>/<strong>{race.total_precincts||'?'}</strong> precincts ({(race.pct_reporting||0).toFixed(1)}%)</span>
        {race.county_name&&<span className="co-tag">{race.county_name}</span>}
      </div>
    </div>
  );
}

const TL = {all:'All',governor:'Governor',us_senate:'U.S. Senate',us_house:'U.S. House',il_senate:'IL Senate',il_house:'IL House',county_sheriff:'Sheriff',county_clerk:'Clerk',county_treasurer:'Treasurer',judicial_circuit:'Judicial'};

function RacesDashboard() {
  const { data, loading, error } = useLiveData('/api/races', 30000);
  const [filter, setFilter] = useState('all');
  const races = data?.races || [];
  const filtered = filter==='all' ? races : races.filter(r=>r.race_type===filter);
  const active = ['all',...new Set(races.map(r=>r.race_type))];
  if (loading) return <div className="loading">Loading races…</div>;
  return (
    <div>
      {error&&<div className="err-banner">⚠ {error}</div>}
      <div className="filters">{Object.keys(TL).filter(t=>active.includes(t)).map(t=>(
        <button key={t} className={`fbtn${filter===t?' active':''}`} onClick={()=>setFilter(t)}>{TL[t]}{t!=='all'&&` (${races.filter(r=>r.race_type===t).length})`}</button>
      ))}</div>
      <div className="sec-hdr"><span className="sec-title">{TL[filter]||filter}</span><span className="sec-ct">{filtered.length} races</span></div>
      {filtered.length===0?<div className="empty">No races to display</div>:<div className="races-grid">{filtered.map(r=><RaceCard key={r.race_id} race={r}/>)}</div>}
    </div>
  );
}

function BellwetherPanel() {
  const { data, loading } = useLiveData('/api/bellwether/top?limit=40', 60000);
  const bws = data?.bellwethers || [];
  const byType = bws.reduce((a,b)=>{const t=b.race_type||'other';if(!a[t])a[t]=[];a[t].push(b);return a;},{});
  if (loading) return <div className="loading">Loading bellwethers…</div>;
  if (!Object.keys(byType).length) return <div className="empty">Bellwether data loads when election cycle is active</div>;
  return (
    <div className="bw-grid">
      {Object.entries(byType).slice(0,4).map(([type,items])=>(
        <div key={type} className="bw-card">
          <div className="bw-title">{type.replace(/_/g,' ')}</div>
          {items.slice(0,8).map(b=>(
            <div key={b.score_id} className="bw-row">
              <div className="bw-l"><div className="bw-name">{b.precinct_name}{b.has_redistricting_caveat&&<span className="cav">⚑</span>}</div><div className="bw-meta">{b.county_name} Co. · {b.cycles_analyzed} cycles</div></div>
              <div className="bw-r"><span className="bw-pct">{b.accuracy_pct}%</span><span className={`bw-st${b.has_reported?' in':' out'}`}>{b.has_reported?'In':'—'}</span></div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function AdminPanel() {
  const { data: sd } = useLiveData('/api/admin/scrapers', 30000);
  const { data: cd, refresh } = useLiveData('/api/results/conflicts', 15000);
  const scrapers = sd?.scrapers || [];
  const conflicts = cd?.conflicts || [];
  async function resolve(result_id, action) {
    await fetch(`${API}/api/results/resolve-conflict`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({result_id,action,user_id:1})});
    refresh();
  }
  return (
    <div>
      <div className="admin-sec">
        <div className="sec-hdr"><span className="sec-title">Scraper Health</span><span className="sec-ct">{scrapers.length} sources</span></div>
        <table className="admin-tbl">
          <thead><tr><th>Source</th><th>Type</th><th>Priority</th><th>Status</th><th>Last Success</th><th>Failures</th></tr></thead>
          <tbody>{scrapers.map(s=>(
            <tr key={s.source_id}>
              <td style={{color:'var(--text)'}}>{s.display_name}</td>
              <td>{s.source_type}</td>
              <td className={s.priority_label==='trusted'?'ok':s.priority_label==='reference'?'warn':''}>{s.priority_label}</td>
              <td>{s.circuit_breaker_open?<span className="err">⚠ Open</span>:s.last_run_status==='success'?<span className="ok">✓ OK</span>:s.last_run_status||'—'}</td>
              <td>{s.last_successful_fetch?new Date(s.last_successful_fetch).toLocaleTimeString():'—'}</td>
              <td className={s.consecutive_failures>0?'err':''}>{s.consecutive_failures||0}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="admin-sec">
        <div className="sec-hdr"><span className="sec-title">Pending Conflicts</span><span className="sec-ct">{conflicts.length}</span></div>
        {conflicts.length===0?<div className="empty">No pending conflicts — all clear</div>:conflicts.map(c=>(
          <div key={c.result_id} className="conf-card">
            <div className="conf-hdr">
              <div><div className="conf-title">{c.office_name}</div><div className="conf-meta">{c.county_name} Co. — {c.precinct_name} — {c.candidate_name}</div></div>
              <div className="conf-meta">{new Date(c.conflict_detected_at).toLocaleTimeString()}</div>
            </div>
            <div className="conf-vals">
              <div className="conf-val"><div className="cv-lbl">Manual Entry</div><div className="cv-num">{c.current_votes?.toLocaleString()}</div><div className="cv-src">{c.override_reason||'No reason'}</div></div>
              <div className="conf-val"><div className="cv-lbl">Scraper Returned</div><div className="cv-num">{c.scraper_votes_pending?.toLocaleString()||'—'}</div><div className="cv-src">{c.scraper_source_pending}</div></div>
            </div>
            <div className="conf-acts">
              <button className="btn btn-a" onClick={()=>resolve(c.result_id,'accept_scraper')}>Accept Scraper</button>
              <button className="btn btn-k" onClick={()=>resolve(c.result_id,'keep_manual')}>Keep Manual</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function App() {
  const [tab, setTab] = useState('races');
  const { data: sum, lastUpdated } = useLiveData('/api/results/summary', 30000);
  const pct = sum?.pct_reporting || 0;
  const t = useClock();

  return (
    <>
      <style>{css}</style>
      <div>
        <header className="header">
          <div className="header-left">
            <div className="logo">SENTINEL<span className="logo-accent">.</span></div>
            <div className="logo-sub">Claymore Strategic Solutions<br/>Election Night Intelligence</div>
          </div>
          <div className="header-right">
            {sum?.is_active&&<div className="live-badge"><div className="live-dot"/>Live</div>}
            <span className="clock">{t.toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit',second:'2-digit'})}</span>
          </div>
        </header>

        <div className="summary-bar">
          <div className="stat-block"><div className="stat-label">Races Called</div><div className="stat-val gold">{sum?.races_called||0}<span className="d">/{sum?.total_races||0}</span></div></div>
          <div className="div"/>
          <div className="stat-block"><div className="stat-label">Precincts In</div><div className="stat-val">{(sum?.precincts_reporting||0).toLocaleString()}<span className="d">/{(sum?.total_precincts||0).toLocaleString()}</span></div></div>
          <div className="div"/>
          <div className="stat-block"><div className="stat-label">Conflicts</div><div className={`stat-val${(sum?.pending_conflicts||0)>0?' red':''}`}>{sum?.pending_conflicts||0}</div></div>
          <div className="div"/>
          <div className="prog-wrap">
            <div className="prog-labels"><span>Statewide Reporting</span><span>{pct.toFixed(1)}%</span></div>
            <div className="prog-track"><div className="prog-fill" style={{width:`${pct}%`}}/></div>
          </div>
          {lastUpdated&&<div className="updated">Updated {lastUpdated.toLocaleTimeString()}</div>}
        </div>

        <nav className="tab-nav">
          {[['races','Races'],['bellwether','Bellwether'],['admin','Admin']].map(([id,label])=>(
            <button key={id} className={`tab-btn${tab===id?' active':''}`} onClick={()=>setTab(id)}>{label}</button>
          ))}
        </nav>

        <main className="main">
          {tab==='races'&&<RacesDashboard/>}
          {tab==='bellwether'&&<BellwetherPanel/>}
          {tab==='admin'&&<AdminPanel/>}
        </main>
      </div>
    </>
  );
}
